import React, { Component } from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { Row, Col } from "react-bootstrap";
import { getProjecTask } from "../../store/actions/projects/projectTasksActions";
import { getProject } from "../../store/actions/projects/projectsActions";

import AssignTaskForm from "./AssignTaskForm";
import TaskAssignments from "./TaskAssignments";

class ViewProjectTask extends Component {
  componentDidMount() {
    const urlParams = new URLSearchParams(this.props.location.search);
    const projectTaskId = urlParams.get("id");
    this.props.getProjecTask(projectTaskId);

    const project = this.props.projects.project;
    if (Object.keys(project).length === 0) {
      const projectId = urlParams.get("project_id");
      this.props.getProject(projectId);
    }
  }

  render() {
    let taskName = "";
    let projectName = "";

    const projectTask = this.props.projects.projectTask;
    if (Object.keys(projectTask).length > 0) {
      const task = projectTask.task;
      if (task) {
        taskName = task.name;
      }

      const project = projectTask.project;
      if (project) {
        projectName = project.project_name;
      }
    }

    return (
      <>
        <Row>
          <Col xs={10} sm={10} md={10} lg={10} xl={10}>
            <h5>{taskName}</h5>
            <div className="text-muted">{projectName}</div>
          </Col>
        </Row>
        <hr />
        <Row>
          <Col>
            <Row className="mt-3">
              <Col>
                <h6>Assign Task To: </h6>
                <AssignTaskForm />
              </Col>
            </Row>
          </Col>
        </Row>
        <Row className="mt-3">
          <Col xs={12} sm={12} md={12} lg={12} xl={12}>
            <h6>Assigned To: </h6>
          </Col>
        </Row>
        <Row>
          <Col xs={12} sm={12} md={12} lg={12} xl={12}>
            <TaskAssignments />
          </Col>
        </Row>
      </>
    );
  }
}

const mapStateToProps = (state) => ({
  projects: state.projects,
});

const mapDispatchToProps = (dispatch) => {
  return {
    getProjecTask: (...args) => dispatch(getProjecTask(...args)),
    getProject: (...args) => dispatch(getProject(...args)),
  };
};

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(ViewProjectTask)
);
